<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-x>
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="attrs"
        v-on="on"
        v-model="selectedAnimalId"
        :placeholder="'Type ID or Select ' + animalType"
        outlined
        dense
      ></v-text-field>
    </template>
    <v-card>
      <v-card-text>
        <v-text-field
          type="text"
          :placeholder="'Search ' + animalType"
          outlined
          dense
          v-model="search"
          @input="getSearchedAnimals"
        ></v-text-field>
        <v-list-item-group color="primary" class="px-0">
          <v-list flat style="max-height: 250px" class="overflow-y-auto">
            <template v-for="animal in animals">
              <v-list-item :key="animal.id" @click="selectanimal(animal.id)">
                <v-list-item-avatar>
                  <v-img :alt="`animal avatar`" :src="imageUrl(animal)"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{
                    `${animal.id} (${animal.name || "N/A"})`
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-list-item-group>
      </v-card-text>
      <div class="gray2 py-3 primary--text text-center">
        <a
          @click="
            () => {
              $router.push({ name: 'Animals', query: { type: animalType } });
            }
          "
          >View All {{ animalType }}’s ({{ this.totalCount }})
        </a>
      </div>
    </v-card>
  </v-menu>
</template>
<script>
//import AnimalService from "@/_services/AnimalService";
import gql from "graphql-tag";

export default {
  apollo: {
    animals: {
      query: gql`
        query animals(
          $categoryId: Int
          $search: String
          $byGroup: Boolean
          $type: String
          $page: Float
          $limit: Float
        ) {
          generalInformations(
            categoryId: $categoryId
            search: $search
            byGroup: $byGroup
            type: $type
            page: $page
            limit: $limit
          ) {
            count
            rows {
              id
              animalIdentification {
                id
                dateOfRegistration
                govRegistrationNo
                livestockName
                identificationMethods {
                  additionalIdentificationMethodId
                  idNumber
                  chipNumber
                  tagNumber
                  tatooName
                  brandName
                  code
                  position
                  tagCategoryId
                  tagColor
                  imageUrl
                }
              }
              birthOrigin {
                id
                dateOfBirth
              }
              breed {
                name
                id
              }
              breedName
              additionalInformation {
                id
                gender
                animalPicture
              }
              gender
              status
              removalInformation {
                id
                reasonForRemoval
              }
            }
            totalCount
          }
        }
      `,
      variables() {
        return {
          byGroup: this.byGroup ? this.byGroup : null,
          type: this.animalType ? this.animalType : "",
          categoryId: this.categoryId,
          search: this.search,
          page: 1,
          limit: 100,
        };
      },
      fetchPolicy: "network-only",
      skip: () => false,
      update: (data) => data.generalInformations.rows,
      result({ data }) {
        this.totalCount = data.generalInformations.totalCount;
        this.count = data.generalInformations.count;
      },
    },
  },
  mounted() {
    (this.selectedAnimalId = this.value), this.getAnimals();
  },
  props: {
    value: {
      required: false,
    },
    animalType: {
      type: String,
      required: true,
    },
    currentAnimal: {
      type: String,
    },
  },
  watch: {
    value: {
      handler(val) {
        this.selectedAnimalId = val;
      },
      deep: true,
    },

    selectedAnimalId: {
      handler(val) {
        // this.selectedAnimalId = val;
        this.$emit("input", val);
        this.menu = false;
      },
      deep: true,
    },
  },
  data() {
    return {
      menu: false,
      selectedAnimalId: this.value,
      search: "",
      animalList: [],
      inputField: "",
      animals: [],
      totalCount: 0,
    };
  },

  methods: {
    getSearchedAnimals() {
      this.animals = this.animals.filter((item) => {
        return item.id.toString().includes(this.search);
      });
    },
    getAnimals() {
      // AnimalService.getAnimalWithGender(
      //   this.animalType.toLowerCase() == "sire" ? "male" : "female",
      //   // {
      //   //     sortBy: "",
      //   //     page: 1,
      //   //     itemsPerPage: 1000,
      //   // },
      //   this.search,
      //   this.currentAnimal
      // )
      //   .then(res => res.data)
      //   .then(data => data.animalList)
      //   .then(animalList => {
      //     this.animalList = animalList;
      //   })
      //   .catch(e => {
      //     console.log("error", e);
      //   });
    },

    imageUrl(animal) {
      return animal?.img?.url || "/img/no_img.png";
    },
    selectanimal(animalId) {
      this.selectedAnimalId = animalId;
      // this.$emit("input", this.selectedAnimalId);
      // this.menu = false;
    },
  },
};
</script>
